import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { postUserOtherAuthCheck } from "api/auth";


const user = (localStorage.getItem("user") !== undefined && localStorage.getItem("user") !== "undefined") ? JSON.parse(localStorage.getItem("user")) : null
const token = localStorage.getItem("token") !== undefined ? localStorage.getItem("token") : ""


const initialState = {
    authUser: user, //user ? user : null,
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: "",
    token,

    allAuthorizedUnits: [],
    allAuthorizedInsts: [],

    allReadAuthorizedInsts: [],
    allReadAuthorizedUnits: [],


};


export const loginUser = createAsyncThunk("loginUser", async (data, thunkAPI) => {
    try {
        return await postUserOtherAuthCheck(data)
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
    }

})
export const logoutUser = createAsyncThunk("logoutUser", async () => {
    await logoutUser2()
})


const logoutUser2 = async () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    window.location.replace(process.env.REACT_APP_MAIN_PAGE_URL);
}




const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        reset: (state) => {
            state.isLoading = false;
            state.isError = false;
            state.isSuccess = false;
            state.message = "";

        },
        loginAuth: (state, action) => {
            state.authUser = action.payload;
        },
        setUserAndToken: (state, action) => {
            state.authUser = action.payload.user;
            state.token = action.payload.token;
            localStorage.setItem("token", action.payload.token);
            localStorage.setItem("user", JSON.stringify(action.payload.user));
        },


        setAllAuthorizedUnits: (state, action) => {
            state.allAuthorizedUnits = action.payload;
        },
        setAllAuthorizedInsts: (state, action) => {
            state.allAuthorizedInsts = action.payload;
        },
        setAllReadAuthorizedInsts: (state, action) => {
            state.allReadAuthorizedInsts = action.payload;
        },
        setAllReadAuthorizedUnits: (state, action) => {
            state.allReadAuthorizedUnits = action.payload;
        }


    },
    extraReducers: (builder) => {
        builder
            .addCase(loginUser.pending, (state) => {
                state.isLoading = true
            })
            .addCase(loginUser.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.authUser = action.payload.user;
                localStorage.setItem("user", JSON.stringify(action.payload.user));
                state.token = token;
            })
            .addCase(loginUser.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
                state.authUser = null;
            })
            .addCase(logoutUser.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = false;
                state.authUser = null;
            })
    }
});

export const { reset, loginAuth, setStockInfo, setUserAndToken, allAuthorizedUnits, setAllAuthorizedUnits, allAuthorizedInsts, setAllAuthorizedInsts, allReadAuthorizedInsts, setAllReadAuthorizedInsts, allReadAuthorizedUnits, setAllReadAuthorizedUnits } = authSlice.actions;
export default authSlice.reducer;
